import {
    ArrayContainerBlock,
    Blocks,
    ContainerBlockVariant,
    isArrayContainerBlock,
    isBlockClientComputed,
    isSingleContainerBlock,
    SlideshowBlockVariant,
} from '../types';

const getArrayContainerBlock = (block: Blocks): ArrayContainerBlock | undefined => {
    if (isSingleContainerBlock(block)) {
        return getArrayContainerBlock(block.container);
    }
    if (isArrayContainerBlock(block)) {
        return block;
    }
    return undefined;
};
const getBlockVariant = (
    arrayContainer: ArrayContainerBlock | undefined,
    block: Blocks,
): ContainerBlockVariant | SlideshowBlockVariant | undefined => {
    if (arrayContainer) {
        return arrayContainer.variant;
    }
    if (isBlockClientComputed(block) && block?.properties?.viewModeVariant) {
        return [ContainerBlockVariant.ungrouped.toLowerCase(), 'ungroup'].includes(block.properties.viewModeVariant)
            ? ContainerBlockVariant.ungrouped
            : ContainerBlockVariant.grouped;
    }

    return (block as any)?.variant;
};
export const getBlockMetaFromBody = (body: Blocks) => {
    if (body) {
        const arrayContainer = getArrayContainerBlock(body);
        return {
            variant: getBlockVariant(arrayContainer, body),
            type: body?.type,
            arrayContainer,
        };
    }
    return undefined;
};
